import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300/60 transition-all duration-300"
    >
      <div className="relative h-48 overflow-hidden">
        <img
          src={article.imageUrl}
          alt={article.title}
          title={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500/90 text-background-50">
            {article.readTime}
          </span>
        </div>
      </div>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-3">
          <span className="text-xs text-foreground-500">{article.date}</span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="text-xs text-foreground-500">{article.author}</span>
        </div>
        <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2">{article.excerpt}</p>
        <div className="flex flex-wrap gap-2 mt-4">
          {article.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="px-2 py-0.5 rounded-md text-xs bg-secondary-100 text-secondary-700">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}